var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainContent aboutContent"},[_c('div',{staticClass:"mainTitle",attrs:{"data-aos":"fade-down","data-aos-duration":"2000"}},[_c('p',[_vm._v("關於我們")])]),_c('div',{staticClass:"container"},[_c('div',{staticClass:"aboutText",attrs:{"data-aos":"fade-up","data-aos-duration":"2000"}},[_c('p',[_vm._v(" 三分鐘即可快速下單、價格透明、專為學生、上班族及小資族服務 ")])])])])
}]

export { render, staticRenderFns }